import { Injectable, isDevMode } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable} from "rxjs";
import firebase from 'firebase/compat/app';
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class HighlightService {
  private env = isDevMode() ? environment.testMode : environment.productionMode;

  constructor(private firestore: AngularFirestore) {
  }

  deleteHighlight(id: any) {
    return this.firestore.collection(this.env.highlights).doc(id).delete()
  }


  getHighlights(): Observable<any> {
    return this.firestore.collection(this.env.highlights, ref =>
      ref.orderBy('eventDate', 'desc')
    ).valueChanges({idField: 'id'})
      ;
  }
  getHighlightsById(id: string): Observable<any> {
    return this.firestore.collection(this.env.highlights).doc(id).valueChanges({idField: 'id'});
  }

  getCentreHighlights(): Observable<any> {
    return this.firestore.collection(this.env.centreHighlights, ref =>
      ref.orderBy('eventDate', 'desc')
    ).valueChanges({idField: 'id'});
  }

  getCentreHighlightsById(id: string): Observable<any> {
    return this.firestore.collection(this.env.centreHighlights).doc(id).valueChanges({idField: 'id'});
  }

  deleteCentreHighlight(id: any):Promise<any> {
    return this.firestore.collection(this.env.centreHighlights).doc(id).delete()
  }

  getHighlightsByFilter(centreCodes: string[], startDate?: Date, endDate?: Date): Observable<any[]> {
    const filterAll = !centreCodes || centreCodes.length === 0 || centreCodes.includes('All');
    return this.firestore.collection<any>(this.env.highlights, ref => {
      let q: firebase.firestore.Query = ref.orderBy('eventDate', 'desc');
      if (!filterAll && centreCodes.length <= 10) {
        q = q.where('centreCode', 'in', centreCodes);
      }
      if (startDate) {
        q = q.where('eventDate', '>=', firebase.firestore.Timestamp.fromDate(startDate));
      }
      if (endDate) {
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);
        q = q.where('eventDate', '<=', firebase.firestore.Timestamp.fromDate(end));
      }
      return q;
    }).valueChanges({idField: 'id'});
  }

}
